export default __webpack_public_path__ + "static/media/cast7.f565ee74.png";